/**
 * useProductsKpiData – KPI-Summary + tägliche Umsatz-Zeitreihen für /v2/products
 */
import { useQuery } from '@tanstack/react-query'
import {
  getProductKpiSummary,
  getSalesDaily,
  type ProductKpiSummary,
  type DailyPoint,
} from '@/lib/api/products-kpi'

export function useProductsKpiData(products: { id: string }[] | undefined): {
  kpi: ProductKpiSummary | null
  seriesByProduct: Record<string, DailyPoint[]>
} {
  const kpiQuery = useQuery({
    queryKey: ['products-kpi'],
    queryFn: getProductKpiSummary,
    staleTime: 60000,
  })

  const visibleIds = (products ?? []).map((p) => p.id)
  const seriesQuery = useQuery({
    queryKey: ['sales-daily', visibleIds],
    queryFn: () => getSalesDaily(visibleIds, 30),
    enabled: visibleIds.length > 0,
    staleTime: 60000,
  })

  return {
    kpi: kpiQuery.data ?? null,
    seriesByProduct: seriesQuery.data ?? {},
  }
}
